// MUI components
import {OrderListingTableRowData} from "../../../assets/types/OrderListingTableRowData";
import React from "react";
// MUI components
import { Chip } from "@mui/material";

// Badges

const badgeStyle = {
	minWidth: "120px",
	fontWeight: "bold",
	color: "white !important",
};

const OpenChip = (
	<Chip label={"Open"} sx={{ ...badgeStyle, backgroundColor: "#ffc107" }} />
);
const WIPChip = (
	<Chip label={"WIP"} sx={{ ...badgeStyle, backgroundColor: "#00a743" }} />
);
const EsclatedChip = (
	<Chip label={"Esclated"} sx={{ ...badgeStyle, backgroundColor: "#de2b2c" }} />
);

const OrderBadge = ({ status }) => {
	if (status === "Open") return OpenChip;
	if (status === "WIP") return WIPChip;
	if (status === "Esclated") return EsclatedChip;
	return <></>;
};


const columns: any[] = [
    {
        headerName: "Merchant Id",
        field: "MerchantId",
    },
    {headerName: "Merchant Name", field: "MerchantName"},
    {headerName: "Reason", field: "reason"},
    {headerName: "Rise Date", field: "riseDate"},
    {headerName: "assignee", field: "assignee"},
    {
		field: "status",
		headerName: "Priority",
		width: 100,
		renderCell: ({ value }) => <OrderBadge status={value} />,
	},
];

const rows: OrderListingTableRowData[] = [
    {
        id: 1,
        orderId: 1,
        productName: ["Cardigan"],
        productSku: 1,
        mrp: "Rs. 1000" ,
        status: "delivered",
        action: "delivered",
        invoice: "link",
        mode:"Cash"
    }
];

const dataTableData = {
    columns,
    rows,
};

export default dataTableData;

